import Vue from "vue";
import Router from "vue-router";
import store from "./store";

import Main from "./views/Main.vue";
import Admin from "./views/Admin.vue";
import notFound from "./views/404.vue";
import Logout from "./views/Logout.vue";
import Product from "./views/Product.vue";
import Profile from "./views/Profile.vue";
import Register from "./views/Register.vue";
import LoginAdmin from "./views/LoginAdmin.vue";
import RegisterCheck from "./views/RegisterCheck.vue";
import products from "./services/products";

Vue.use(Router);

const router = new Router({
	mode: "history",
	routes: [
		{
			path: "/",
			name: "main",
			component: Main,
		},
		{
			path: "/login",
			name: "login",
			component: () => { 
				return import('@/views/Login.vue');
		   }
		},
		{
			path: "/register/:token",
			name: "register_token",
			component: () => { 
				return import('@/views/Register.vue');
		   }
		},
		{
			path: "/register",
			name: "register",
			component: Register,
		},
		{
			path: "/register/check/:client_user_uid/:token",
			name: "register_check",
			component: RegisterCheck,
		},
		{
			path: "/login_admin",
			name: "login_admin",
			component: LoginAdmin,
		},
		{
			path: "/password/:id",
			name: "password",
			component: () => { 
				return import('@/views/Password.vue');
		   }
		},
		{
			path: "/password_reset",
			name: "password_reset",
			component: () => { 
				return import('@/views/PasswordReset.vue');
		   }
		},
		{
			path: "/logout",
			name: "logout",
			component: Logout,
		},
		{
			path: "/profile",
			name: "profile",
			component: Profile,
		},
		{
			path: "/admin",
			name: "admin",
			component: Admin,
		},
		{
			path: "/products/:slug",
			name: "product",
			component: Product
		},
		{
			path: "/*",
			name: "404",
			component: notFound,
		},
	],
});

router.beforeEach((to, from, next) => {
	//if (from.database == to.database)
	//console.log(to);

	/*if (!to.path.startsWith("/login") && 
		!to.path.startsWith("/password") && 
		!to.path.startsWith("/form/") &&
		!to.path.startsWith("/register")) {
		let jwt = store.state.jwt;
		if (jwt) {
			next();
		} else {
			next("login");
		}
	} else {
		next();
	}*/
	next()
});

export default router;
